<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(utc)
dayjs.extend(customParseFormat)

export default {
    name: "SortedCheckboxTable",

    props: {
        headers: {
            type: Array,
            default: () => []
        },
        rows: {
            type: Array,
            default: () => []
        }
    },
    
    emits: ['data-changed'],

    data() {
        return {
            rowsToEdit: this.rows,
            sortName: '',
            sortDir: 'asc',
            sortType: ''
        }
    },

    computed: {
        sortedRows() {
            if (this.sortName === '') {
                return this.rowsToEdit
            }
            else {
                return this.rowsToEdit.slice().sort(this.customSort(this.sortDir !== 'desc', this.sortName, this.sortType))
            }
        }
    },

    watch: {
        rows: function() {
            let i = this.sortedRows.findIndex(r => r.selected)
            if (this.$refs.table != null && this.$refs.table.rows.count > 0 && i > 0) {
                this.$refs.table.rows[i + 1].scrollIntoView({ behavior: "smooth", block: "nearest" })
            }
        }
    },

    methods: {
        customSort(asc, sortName, type) {
            return function (a, b) {
                let ca = a.cells.find(c => c.id === sortName).content
                let cb = b.cells.find(c => c.id === sortName).content

                if (asc) {
                    if (ca == null || ca.length === 0)
                        return -1
                    if (cb == null || cb.length === 0)
                        return 1
                    switch (type) {
                        case 'date':
                            return dayjs(ca, 'D.M.YYYY').toDate() - dayjs(cb, 'D.M.YYYY').toDate()
                        case 'number':
                            return ca - cb
                        default:
                            return ca.localeCompare(cb)
                    }
                }
                else {
                    if (ca == null || ca.length === 0)
                        return 1
                    if (cb == null || cb.length === 0)
                        return -1
                    switch (type) {
                        case 'date':
                            return dayjs(cb, 'D.M.YYYY').toDate() - dayjs(ca, 'D.M.YYYY').toDate()
                        case 'number':
                            return cb - ca
                        default:
                            return cb.localeCompare(ca)
                    }
                }
            }
        },
        sortRows(headerIndex) {
            if (this.headers[headerIndex].sort) {
                if (this.sortName === this.headers[headerIndex].id) {
                    this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
                }
                else {
                    this.sortDir = 'asc'
                }
                this.sortName = this.headers[headerIndex].id
                if (this.headers[headerIndex].sortType != null) {
                    this.sortType = this.headers[headerIndex].sortType
                }
                else {
                    this.sortType = ''
                }
            }
        },
        checkboxChange() {
            this.$emit('data-changed', this.rowsToEdit)
        }
    }
}
</script>


<template>
    <table ref="table">
        <thead v-if="headers.length > 0">
            <tr>
                <th>&nbsp;</th>
                <th v-for="(h, i) in headers" :key="i" @click="sortRows(i)" :style="h.width != null ? 'max-width: ' + h.width + 'px; min-width: ' + h.width + 'px; text-overflow: ellipsis; overflow: hidden;' : ''">
                    <span style="white-space: pre-line; float: left;">{{ h.name.length > 0 ? h.name.replaceAll(' ', '&nbsp;') : '&nbsp;' }}</span>
                    <img v-if="sortName.length > 0 && sortName === h.id && sortDir === 'asc'" src="@/assets/images/chevron-up.svg" class="sort" />
                    <img v-else-if="sortName.length > 0 && sortName === h.id && sortDir === 'desc'" src="@/assets/images/chevron-down.svg" class="sort sort-down" />
                    <span v-else class="nosort"></span>
                </th>
            </tr>
        </thead>

        <tbody v-if="rows.length > 0">
            <tr v-for="(r, j) in sortedRows" :key="j">
                <td><input type="checkbox" v-model="r.selected" @change="checkboxChange"></td>
                <td v-for="(c, k) in r.cells" :key="k" :title="c.width != null ? c.content : ''" :style="c.width != null ? 'max-width: ' + c.width + 'px; min-width: ' + c.width + 'px; text-overflow: ellipsis; overflow: hidden;' : ''">
                    <span>{{ c.content }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>